<script setup>
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import { storeToRefs } from 'pinia'
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'

const store = useInvestmentProcessDataState()
const { giftMembership } = storeToRefs(store)
</script>

<template>
    <div class="relative flex items-start pt-4">
        <div class="flex h-6 items-center">
            <input
                id="giftMembership"
                v-model="giftMembership"
                aria-describedby="gift-membership-description"
                name="giftMembership"
                type="checkbox"
                class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" />
        </div>
        <div class="ml-3 text-sm leading-6">
            <label for="giftMembership" class="font-semibold text-gray-900">{{
                $t('investment_process.accept_gift_membership')
            }}</label>
        </div>
    </div>
</template>

<style scoped></style>
